import { makeStyles } from '@material-ui/core/styles';
import { BORDER_RADIUS } from 'consts/styles/Main';

const useStyles = makeStyles(theme => ({
  Wrapper: {
    '&__switcher-wrapper': {
      maxHeight: 200,
      overflowY: 'auto',
    },
    '&__history-wrapper': {
      padding: '20px 15px 0 0',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%',
    },
    '&__history-wrapper-short': {
      padding: '15px 10px 15px 0',
      overflowY: 'auto',
      overflowX: 'hidden',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    '&__details-wrapper': {
      width: 500,
      display: 'block',
      flexDirection: 'column',
      background: 'rgba(11, 17, 32, 0.88)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(14, 165, 233, 0.12)',
      height: 'auto',
      overflowX: 'hidden',
      borderRadius: 8,
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: '5vh',
      left: '5vw',
    },
  },
}));

export default useStyles;
